export const capitalizeFirstLetter = (text) => {
	return text.charAt(0).toUpperCase() + text.slice(1);
};

const escapeRegExp = (text) => {
	return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
};

export const replaceAll = (str, find, replace) => {
	return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
};

export const generateRandomString = (length: number) => {
	let result = "";
	const characters =
		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	const charactersLength = characters.length;
	for (let i = 0; i < length; i++) {
		result += characters.charAt(
			Math.floor(Math.random() * charactersLength)
		);
	}
	return result;
};
export function convertToDecimal(num: number): number {
	if (num === Math.round(num)) {
		return Math.round(num);
	} else {
		return parseFloat(num.toFixed(2));
	}
}
